<div style="margin-top: 20px; margin-left: 20px;">
  <form [formGroup]="form">
    <div class="mb-3 row" [ngClass]="{'has-error':!username.valid}">
      <span class="col-lg-2">Username:</span>
      <div class="col-lg-5">
        <input class="form-control" type="text" [formControl]="username" />
      </div>
      @if (username.hasError('required')) {
        <div class="col-lg-3 alert alert-danger"
          style="padding: 5px; margin-bottom: 0px;">
          Username is required
        </div>
      }
    </div>
    <div class="mb-3 row" [ngClass]="{'has-error':!firstName.valid}">
      <span class="col-lg-2">First Name:</span>
      <div class="col-lg-5">
        <input class="form-control" type="text" [formControl]="firstName" />
      </div>
      @if (firstName.hasError('required')) {
        <div class="col-lg-3 alert alert-danger"
          style="padding: 5px; margin-bottom: 0px;">
          First Name is required
        </div>
      }
    </div>
    <div class="mb-3 row" [ngClass]="{'has-error':!lastName.valid}">
      <span class="col-lg-2">Last Name:</span>
      <div class="col-lg-5">
        <input class="form-control" type="text" [formControl]="lastName" />
      </div>
      @if (lastName.hasError('required')) {
        <div class="col-lg-3 alert alert-danger"
          style="padding: 5px; margin-bottom: 0px;">
          Last Name is required
        </div>
      }
    </div>
    <div class="mb-3 row" [ngClass]="{'has-error':!email.valid}">
      <span class="col-lg-2">Email:</span>
      <div class="col-lg-5">
        <input class="form-control" type="text" [formControl]="email" />
      </div>
      @if (email.hasError('required')) {
        <div class="col-lg-3 alert alert-danger"
          style="padding: 5px; margin-bottom: 0px;">
          Email is required
        </div>
      }
    </div>
    <div class="mb-3 row" [ngClass]="{'has-error':!userClass.valid}">
      <span class="col-lg-2">User Type:</span>
      <div class="col-lg-3">
        <select class="form-control" [formControl]="userClass">
          <option value="Administrator">Administrator</option>
          <option value="Regular">Regular</option>
          <option value="Observer">Observer</option>
        </select>
      </div>
      <user-type-info class="col-lg-1"></user-type-info>
    </div>
    <div class="mb-3 row" [ngClass]="{'has-error':!active.valid}">
      <div class="col-lg-5">
        <input type="checkbox" [formControl]="active" />
        <span class="uv-checkbox-label">Active</span>
      </div>
    </div>
    <div class="mb-3 row" [ngClass]="{'has-error':form.hasError('validPassword')}">
      <span class="col-lg-2">Password:</span>
      <div class="col-lg-5">
        <input class="form-control" type="password" [formControl]="password" />
      </div>
      @if (form.hasError('validPassword')) {
        <div class="col-lg-3 alert alert-danger"
          style="padding: 5px; margin-bottom: 0px;">
          Password is required
        </div>
      }
    </div>
    <div class="mb-3 row" [ngClass]="{'has-error':form.hasError('passwordsEqual')}">
      <span class="col-lg-2">Confirm Password:</span>
      <div class="col-lg-5">
        <input class="form-control" type="password" [formControl]="confirmPassword" />
      </div>
      @if (form.hasError('passwordsEqual')) {
        <div class="col-lg-5 alert alert-danger"
          style="padding: 5px; margin-bottom: 0px;">
          Confirm Password must be the same as Password
        </div>
      }
    </div>
  </form>

  <hr />

  <div style="height: 40px;">
    <span class="label-text"
    style="display: inline-block; margin-left: calc(50% - 25px); padding-top: 5px;">Groups</span>
    <button pButton icon="fa fa-plus-square-o" style="float: right;" label="Add Groups"
    title="Add groups for this user" class="add-button" (click)="addGroups()"></button>
  </div>

  @if (hasGroupEntries) {
    <div style="padding-bottom: 10px;">
      <p-table #dt class="user-groups-table" [value]="entries" [resizableColumns]="true" [scrollable]="true"
        scrollHeight="calc(280px)">
        <ng-template pTemplate="header">
          <tr>
            <th pResizableColumn pSortableColumn="groupname">
              Name
              <p-sortIcon field="groupname"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="class">
              Class
              <p-sortIcon field="class"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="type">
              Type
              <p-sortIcon field="type"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="active">
              Active
              <p-sortIcon field="active"></p-sortIcon>
            </th>
            <th class="uv-table-button-column-1">
            </th>
          </tr>
          <tr>
            <th>
              <input pInputText type="text" (input)="dt.filter($event.target.value, 'groupname', 'contains')"
                style="width: 100%;">
              </th>
              <th>
                <input pInputText type="text" (input)="dt.filter($event.target.value, 'class', 'contains')"
                  style="width: 100%;">
                </th>
                <th>
                  <input pInputText type="text" (input)="dt.filter($event.target.value, 'type', 'contains')"
                    style="width: 100%;">
                  </th>
                  <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'active', 'contains')"
                      style="width: 100%;">
                    </th>
                    <th class="uv-table-button-column-1">
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                  <tr [pSelectableRow]="rowData">
                    <td>
                      <span class="uv-table-value">{{rowData.groupname}}</span>
                    </td>
                    <td>
                      <span class="uv-table-value">{{rowData.class}}</span>
                    </td>
                    <td>
                      <span class="uv-table-value">{{rowData.type}}</span>
                    </td>
                    <td>
                      <span class="uv-table-value">{{rowData.active}}</span>
                    </td>
                    <td class="uv-table-button-column-1">
                      <button type="button" class="btn btn-danger uv-first-table-button"
                        title="Remove user from this group" [disabled]="!rowData.isNative"
                        (click)="removeGroup(rowData.tag)">
                        <i class="pi pi-trash"></i>
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          }

          @if (!hasGroupEntries) {
            <div class="message-text">
              No groups have been added
            </div>
          }

          <group-selector [(visible)]="groupSelectorVisible" header="Select groups to add" [minGroups]="1"
            [maxGroups]="1000000" format="full" [except]="excludedGroupGuids"
          (onOk)="addUserToSelectedGroups($event)"></group-selector>

        </div>
